import RouteWithTrips from "@/components/Passenger/models/RouteWithTrips";
import VectorLayer from "ol/layer/Vector"
import VectorSource from "ol/source/Vector"
import DestinationFeature from "@/components/Map/Features/DestinationFeature";

export default class DestinationLayer extends VectorLayer<VectorSource> {
  protected destinationSource = new VectorSource();

  constructor(options?: any) {
    super({ zIndex: 2, ...options });
    this.setSource(this.destinationSource);
  }

  showDestinations(route: RouteWithTrips) {
    this.destinationSource.clear();
    route.destinations.forEach(d => {
      if (d.latitude && d.longitude) {
        const passengerName = route.trips.find(t => d.trips.includes(t.id)).passenger.name;
        this.destinationSource.addFeature(new DestinationFeature(d, passengerName));
      }
    });
  }

  selectDestinationByTripId(tripId: number) {
    this.destinationSource.getFeatures().forEach(feature => {
      const destinationFeature = feature as DestinationFeature;
      const destinationContainsSelectedTrip = destinationFeature.destination.trips.includes(tripId);
      if (destinationFeature.isSelected !== destinationContainsSelectedTrip) {
        destinationFeature.toggleSelection();
      }
    });
  }
}